import { toVoiceMediaProperties, VoiceMediaProperties } from "./VoiceMediaProperties";
import {
    ConversationMediaProperties,
    toConversationMediaProperties
} from "~/modules/participant/ConversationMediaProperties";
import {
    MediaChannelType,
    ParticipantType,
    ParticipantEventData,
    RoutingProperties,
    CbmParticipant
} from "~/modules/cbm/Cbm";




export type ExtendedParticipantEventData = ParticipantEventData & {
    error_data?: {
        error_message: string;
        error_code: number;
    } | null;
};





export type TaskParticipant = VoiceTaskParticipant | ConversationTaskParticipant;





export interface BaseParticipant {
    


    readonly participantSid: string;
    


    readonly type: ParticipantType;
    


    readonly channelSid: string;
    


    readonly interactionSid: string;
    


    readonly routingProperties?: RoutingProperties | null;

    readonly errorData: {
        errorMessage: string;
        errorCode: number;
    } | null;
}





export type VoiceTaskParticipant = BaseParticipant & {
    readonly channelType: MediaChannelType.Voice;
    


    readonly mediaProperties?: VoiceMediaProperties | null;
    


    readonly isOnHold: boolean;
};





export type ConversationTaskParticipant = BaseParticipant & {
    


    readonly channelType: Exclude<MediaChannelType, MediaChannelType.Voice>;
    


    readonly mediaProperties?: ConversationMediaProperties | null;
};

export function participantDataToTaskParticipant(participant: ExtendedParticipantEventData): TaskParticipant {
    if (participant.channel_type === MediaChannelType.Voice) {
        const mediaProperties = toVoiceMediaProperties(participant.media_properties ?? {});
        return {
            participantSid: participant.participant_sid,
            type: participant.type,
            channelType: participant.channel_type,
            channelSid: participant.channel_sid,
            interactionSid: participant.interaction_sid,
            routingProperties: participant.routing_properties
                ? {
                      taskSid: participant.routing_properties?.task_sid,
                      reservationSid: participant.routing_properties?.reservation_sid,
                      workerSid: participant.routing_properties?.worker_sid
                  }
                : null,
            mediaProperties,
            errorData: participant.error_data
                ? {
                      errorMessage: participant.error_data.error_message,
                      errorCode: participant.error_data.error_code
                  }
                : null,
            isOnHold: mediaProperties.hold
        };
    }

    const mediaProperties = toConversationMediaProperties(participant.media_properties ?? {});
    return {
        participantSid: participant.participant_sid,
        type: participant.type,
        channelType: participant.channel_type,
        channelSid: participant.channel_sid,
        interactionSid: participant.interaction_sid,
        routingProperties: participant.routing_properties
            ? {
                  taskSid: participant.routing_properties?.task_sid,
                  reservationSid: participant.routing_properties?.reservation_sid,
                  workerSid: participant.routing_properties?.worker_sid
              }
            : null,
        mediaProperties,
        errorData: participant.error_data
            ? {
                  errorMessage: participant.error_data.error_message,
                  errorCode: participant.error_data.error_code
              }
            : null
    };
}

export function cbmParticipantToTaskParticipant(participant: CbmParticipant): TaskParticipant {
    return participantDataToTaskParticipant({
        participant_sid: participant.participantSid,
        type: participant.type,
        channel_type: participant.channelType,
        channel_sid: participant.channelSid,
        interaction_sid: participant.interactionSid,
        routing_properties: participant.routingProperties
            ? {
                  task_sid: participant.routingProperties.taskSid,
                  reservation_sid: participant.routingProperties?.reservationSid,
                  worker_sid: participant.routingProperties?.workerSid
              }
            : null,
        media_properties: participant.mediaProperties ?? null,
        error_data: null
    });
}
